import { css } from '@emotion/core';

export const rotate = (isActive: boolean) => css`
	transition: transform 0.3s ease;
	transform-origin: center;
	transform: ${isActive ? 'rotate(180deg)' : 'rotate(0deg)'};
`;
